module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-tra-cuu"
  }, [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Kế hoạch điều động tàu ngày " + _vm._s(_vm.searchTopTauAll))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "8px 8px 0px 10px"
    }
  }, [_vm._v("\n      Ngày: \n    ")]), _vm._v(" "), _c('v-menu', {
    ref: "menuTopTau",
    staticStyle: {
      "margin-top": "8px"
    },
    style: ({}),
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menuTopTauAll),
      callback: function($$v) {
        _vm.menuTopTauAll = $$v
      },
      expression: "menuTopTauAll"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0 my-0",
    attrs: {
      "slot": "activator",
      "persistent-hint": ""
    },
    slot: "activator",
    model: {
      value: (_vm.searchTopTauAll),
      callback: function($$v) {
        _vm.searchTopTauAll = $$v
      },
      expression: "searchTopTauAll"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": ""
    },
    on: {
      "input": function($event) {
        _vm.menuTopTauAll = false
      }
    },
    model: {
      value: (_vm.dateSearchTopTauAll),
      callback: function($$v) {
        _vm.dateSearchTopTauAll = $$v
      },
      expression: "dateSearchTopTauAll"
    }
  })], 1), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "margin-left": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "size": "17"
    },
    on: {
      "click": function($event) {
        _vm.menuTopTauAll = !_vm.menuTopTauAll
      }
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('v-switch', {
    staticClass: "ml-4 mt-2",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.changeTypePart
    },
    model: {
      value: (_vm.switch1),
      callback: function($$v) {
        _vm.switch1 = $$v
      },
      expression: "switch1"
    }
  })], 1), _vm._v(" "), (_vm.loadingDataItem) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataItems), function(value, name) {
    return _c('div', [_c('div', {
      staticClass: "caption-header mt-3"
    }, [_vm._v("\n      " + _vm._s(value[0]['portRegionName']) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3",
      staticStyle: {
        "overflow": "auto"
      }
    }, [_c('v-data-table', {
      staticClass: "table-bordered danhSachHoSoTable__class",
      attrs: {
        "headers": _vm.headersKhDieuDong,
        "items": value,
        "hide-actions": "",
        "no-data-text": 'Không tìm thấy hồ sơ ',
        "no-results-text": 'Không tìm thấy hồ sơ '
      },
      scopedSlots: _vm._u([{
        key: "headers",
        fn: function(props) {
          return [_c('tr', {
            staticStyle: {
              "background": "#316BB6",
              "color": "#ffff"
            }
          }, _vm._l((props.headers), function(header) {
            return _c('th', {
              staticStyle: {
                "color": "#ffff !important",
                "font-weight": "normal !important"
              },
              domProps: {
                "innerHTML": _vm._s(header.text)
              }
            })
          }))]
        }
      }, {
        key: "items",
        fn: function(props) {
          return _vm._l((_vm.headersKhDieuDong), function(itemKey, index) {
            return _c('td', {
              staticClass: "text-xs-center",
              style: (_vm.headersKhDieuDong[index]['style'])
            }, [(itemKey.id === 'chanelCodeList') ? _c('div', _vm._l((props.item[itemKey.display]), function(item, index) {
              return _c('div', {
                key: 'chanelCodeList' + index
              }, [_vm._v(_vm._s(item))])
            })) : (itemKey.id === 'timeOfArrival') ? _c('div', [(props.item['noticeShipType'] === 1 || props.item['noticeShipType'] === '1') ? _c('div', [_vm._v("\n                " + _vm._s(props.item['timeHHMMOfArrival']) + "\n              ")]) : _c('div', [_vm._v("\n                " + _vm._s(props.item['timeHHMMOfDeparture']) + "\n              ")])]) : (itemKey.id === 'tugboatList') ? _c('span', [(props.item['shortTugboatList'] && props.item['shortTugboatList'] !== 'null') ? _c('div', {
              staticStyle: {
                "font-size": "10px"
              },
              domProps: {
                "innerHTML": _vm._s(props.item['shortTugboatList'])
              }
            }) : _c('div', {
              staticStyle: {
                "font-size": "10px"
              },
              domProps: {
                "innerHTML": _vm._s(props.item['tugboatList'])
              }
            })]) : (itemKey.id === 'pilotList') ? _c('span', [(props.item['shortPilotList'] && props.item['shortPilotList'] !== 'null') ? _c('div', {
              staticStyle: {
                "font-size": "10px"
              },
              domProps: {
                "innerHTML": _vm._s(props.item['shortPilotList'])
              }
            }) : _c('div', {
              staticStyle: {
                "font-size": "10px"
              },
              domProps: {
                "innerHTML": _vm._s(props.item['pilotList'])
              }
            })]) : ((props.item['noticeShipType'] === 2 || props.item['noticeShipType'] === '2') && itemKey.id === 'portHarbourCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['portHarbourShortName']) + ", " + _vm._s(props.item['portWharfShortName']))])]) : ((props.item['noticeShipType'] === 2 || props.item['noticeShipType'] === '2') && itemKey.id === 'portWharfCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['initFrom'] || 'P/S'))])]) : ((props.item['noticeShipType'] === 1 || props.item['noticeShipType'] === '1') && itemKey.id === 'portHarbourCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['initFrom'] || 'P/S'))])]) : ((props.item['noticeShipType'] === 1 || props.item['noticeShipType'] === '1') && itemKey.id === 'portWharfCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['portHarbourShortName']) + ", " + _vm._s(props.item['portWharfShortName']))])]) : (itemKey.id === 'portHarbourCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(_vm.checkInitfrom(props.item)))])]) : (itemKey.id === 'portWharfCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['portHarbourShortName']) + ", " + _vm._s(props.item['portWharfShortName']))])]) : (itemKey.id === 'maxDraft') ? _c('span', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['maxDraft'] ? props.item['maxDraft'].replace('/', ' / ') : ''))])]) : (itemKey.id === 'shipAgencyCode') ? _c('span', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['shipAgencyShortName'] ? props.item['shipAgencyShortName'] : props.item['shipAgencyName']))])]) : _c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item[itemKey.display]))])])
          })
        }
      }])
    })], 1)])
  }), _vm._v(" "), _vm._l((_vm.arrNotData), function(item) {
    return _c('div', {
      staticClass: "caption-header mt-3"
    }, [_vm._v("\n    " + _vm._s(item) + "\n  ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cf9eed4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KeHoachDieuDongTau_2.vue
// module id = 724
// module chunks = 1